module.exports = __webpack_public_path__ + "img/LaBase-Edo-burger-600.a74f932a.jpg";